import React from 'react'
import { AnimatedPathWrapper } from '../AnimatedPathWrapper'
import { type IconProps } from '../IconPropsInterface'

export const CarouselArrowLeft: React.FC<React.PWC<IconProps>> = ({
  color,
  size,
  hoveringColor,
}) => (
  <AnimatedPathWrapper
    hoveringColor={hoveringColor}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 4.5L7.5 12L15 19.5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </AnimatedPathWrapper>
)
